export const LIVE_GAME_IMAGE_UPDATE_INTERVAL = 20000;
